import React, { useEffect, useContext,  useRef, useState  } from 'react';
import styles from './ServiceOrdersTab.module.css';
import commonStyles from 'GlobalComponents/CommonStyles.module.css';
import RunTypeSelect  from './RunTypeSelect.js';
import TestScenarios from './TestScenarios.js';
import GlobalButton from 'GlobalComponents/GlobalButton/GlobalButton.js';
import PageHeader from 'Contexts/PageHeader/PageHeader.js';

import {QuoteMasterContext} from 'Contexts/QuoteMasterContext.js'; 

import NewSOSameParametersButton from './NewSOSameParametersButton.js';
import Icon from 'GlobalComponents/Icon/Icon.js';
import SearchBar from 'GlobalComponents/SearchBar/SearchBar.js';
import LoadServiceOrderButton from './LoadServiceOrderButton.js';

export default function ServiceOrdersTab({setIsUserAdminPanelOpen, handleGetServiceOrders, serviceOrdersTabWidth, setIsProvidersPanelOpen, setIsRunningServiceOrdersPanelOpen, setIsWAErrorReportOpen }) {
    const {user, serviceOrders, currentServiceOrder, setCurrentServiceOrder, setSOToDelete, settriggerServiceOrderTabCleanup, triggerServiceOrderTabCleanup, freshServiceOrder} = useContext(QuoteMasterContext);
    const [searchTerm, setSearchTerm] = useState('');
    const [rawOrders, setRawOrders] = useState(serviceOrders);
    const [ordersToDisplay, setOrdersToDisplay] = useState(serviceOrders);
    const [view, setView] = useState('all');
    const testScenarioRef = useRef(null);
    const runTypeRef = useRef(null);
    const scrollBarWidth = useRef(0);
    const serviceOrdersContainerRef = useRef(null);
    const [serviceIrdersContainerRightPadding, setServiceIrdersContainerRightPadding] = useState(16);

    useEffect(() => {
        if(triggerServiceOrderTabCleanup){
            settriggerServiceOrderTabCleanup(false);
            newServiceOrder();
        }
    }, [triggerServiceOrderTabCleanup]);

    const newServiceOrder = () => {
        setCurrentServiceOrder({...freshServiceOrder, user: user});
        if (testScenarioRef.current) {
            testScenarioRef.current.resetScenario();
        }
        if (runTypeRef.current) {
            runTypeRef.current.resetRunType();
        }
    }

    useEffect(() => {
        runTypeRef.current = currentServiceOrder.runType;
    }, [currentServiceOrder.runType]);

    useEffect(() => {
        testScenarioRef.current = currentServiceOrder.testScenario;
    }, [currentServiceOrder.testScenario]);


    useEffect(() => {
        let newOrdersToDisplay = [...serviceOrders]
        switch(view){
            case 'regular':
                newOrdersToDisplay = newOrdersToDisplay.filter(order => order.runType === 'regular');
                break;
            case 'test':
                newOrdersToDisplay = newOrdersToDisplay.filter(order => order.runType !== 'regular');
                break;
            default:
                // just keep the original order
                break;
        }
        newOrdersToDisplay = newOrdersToDisplay.slice().sort((a, b) => new Date(b.timeLastUpdate) - new Date(a.timeLastUpdate));
        setRawOrders(newOrdersToDisplay);

        if(searchTerm===''){
            setOrdersToDisplay(newOrdersToDisplay);
        }
    }, [view, serviceOrders]);          

    useEffect(() => {
        if(serviceOrdersContainerRef.current.scrollHeight > serviceOrdersContainerRef.current.clientHeight){ // if there is a scrollbar
            scrollBarWidth.current = 4;
        } else {
            scrollBarWidth.current = 0;
        }
        setServiceIrdersContainerRightPadding(16-scrollBarWidth.current);
    }, [serviceOrders, serviceOrdersContainerRef.current]);


    return(
        <div className={styles.serviceOrdersTab} style={{minWidth: `${serviceOrdersTabWidth}px`, maxWidth: `${serviceOrdersTabWidth}px`}}>
            <div style={{padding: '0px 16px'}} >
                <PageHeader setIsUserAdminPanelOpen={setIsUserAdminPanelOpen} setIsProvidersPanelOpen={setIsProvidersPanelOpen} setIsRunningServiceOrdersPanelOpen={setIsRunningServiceOrdersPanelOpen} setIsWAErrorReportOpen={setIsWAErrorReportOpen}/>
                <div className={styles.selectors}>
                    <RunTypeSelect FowardingRef={runTypeRef}/>
                </div>
                {currentServiceOrder.runType === 'standardTest' && 
                    <div className={styles.selectors}>
                        <TestScenarios FowardingRef={testScenarioRef} />
                    </div>
                }   
                <div className={styles.workspace}>
                    <GlobalButton 
                        onClick={()=>newServiceOrder()}
                        label={<>Nova Ordem de Serviço <br/>em Branco</>}
                        type={'primary'}
                        width={'100%'}
                    />
                </div>
                <div className={styles.workspace}>
                    <NewSOSameParametersButton />
                </div>
                <span className={styles.workspace} style={{borderTop: '1px solid var(--border-dark)', justifyContent: 'space-between'}}>
                    <div className={styles.serviceOrdersLabel}>Ordens de Serviço</div>
                    {Icon({originalIcon:'restorePageOutlined', size:32, onClick:handleGetServiceOrders, tooltipMessage:'Atualizar lista de Ordem de Serviços', tooltipPlacement:"bottom"})}    
                </span>
                <div className={commonStyles.detailsAndCostButtons} >
                    <GlobalButton  onClick={() => setView('all')} label='Todas' width='68px' type={view === 'all' ? 'selected' : 'secondary'} />
                    <GlobalButton  onClick={() => setView('regular')} label='Produção' width='68px' type={view === 'regular' ? 'selected' : 'secondary'} />
                    <GlobalButton  onClick={() => setView('test')} label='Testes' width='68px' type={view === 'test' ? 'selected' : 'secondary'} />
                </div>
                <div className={styles.workspace} >
                    <SearchBar 
                        groupToSearch={rawOrders} 
                        setGroup={setOrdersToDisplay} 
                        toolTipTitle={'Ordem de Serviço, Afiliado e Usuário'}
                        keys={['providers.providerName', 'serviceOrderId', 'user.userEmail', 'user.firstName', 'user.lastName']}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                    />
                </div>
            </div>
            <ul className={styles.serviceOrdersArea} ref={serviceOrdersContainerRef} style={{paddingRight:serviceIrdersContainerRightPadding}}>
                {ordersToDisplay.map((serviceOrder, index) =>(
                    <div className={styles.workspace} key={serviceOrder.serviceOrderId} >
                        <LoadServiceOrderButton serviceOrder={serviceOrder}/>
                        <Icon originalIcon={'deleteUser'} size={28} onClick={()=>setSOToDelete(serviceOrder.serviceOrderId)} />
                    </div>
                ))}
            </ul>	
    </div>
    )
}